import { apiClient } from '../lib/api';
import type { AuthResponse, Profile, Address } from '../types';

export const authService = {
    loginWithGoogle: async (idToken: string): Promise<AuthResponse> => {
        return apiClient.loginWithGoogle(idToken);
    },

    getProfile: async (): Promise<Profile> => {
        return apiClient.request<Profile>('/auth/me/');
    },

    updateProfile: async (data: Partial<Profile>): Promise<Profile> => {
        // Assuming PATCH endpoint exists or will exist.
        // The doc says GET /api/auth/me/ but doesn't explicitly mention update yet, 
        // but usually it's PATCH /api/auth/me/ or similar. 
        // For now I'll implemented it assuming standard REST.
        return apiClient.request<Profile>('/auth/me/', {
            method: 'PATCH',
            body: JSON.stringify(data),
        });
    },

    // Addresses (can be here or in addressService, putting here for now as part of 'user')
    getAddresses: async (): Promise<Address[]> => {
        return apiClient.request<Address[]>('/addresses/');
    },

    createAddress: async (address: Omit<Address, 'uuid' | 'created_at'>): Promise<Address> => {
        return apiClient.request<Address>('/addresses/', {
            method: 'POST',
            body: JSON.stringify(address),
        });
    }
};
